'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface Stat {
  icon: string;
  value: string;
  label: string;
}

const ImpactStats = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const stats: Stat[] = [];

  if (!isHydrated) {
    return (
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="bg-surface rounded-xl p-6 text-center shadow-brand-sm"
          >
            <div className="w-12 h-12 bg-brand-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon
                name={stat.icon as any}
                size={24}
                variant="outline"
                className="text-brand-primary"
              />
            </div>
            <div className="text-3xl font-bold text-text-primary mb-2">
              {stat.value}
            </div>
            <div className="text-sm text-text-secondary">{stat.label}</div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-surface rounded-xl p-6 text-center shadow-brand-sm hover:shadow-brand-md transition-all duration-300"
        >
          <div className="w-12 h-12 bg-brand-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon
              name={stat.icon as any}
              size={24}
              variant="outline"
              className="text-brand-primary"
            />
          </div>
          <div className="text-3xl font-bold text-text-primary mb-2">
            {stat.value}
          </div>
          <div className="text-sm text-text-secondary">{stat.label}</div>
        </div>
      ))}
    </div>
  );
};

export default ImpactStats;